<ng-template #nodesList let-context>
    <div *ngFor="let node of tree.getFilteredItems(filterQuery, context.nodes); trackBy: trackByFn">
        <div
            class="tree-node"
            [customProperty]="{'--level': context.level}"
            [ngClass]="{expanded: tree.isChildrenExpanded(node), parent: node.hasChildren()}"
            (click)="onNodeClick(node, checkboxEl)"
        >
            <button type="button" class="toggle-children-btn special" *ngIf="node.hasChildren()"></button>
            <checkbox
                #checkboxEl
                [ngModel]="tree.getCheckboxState(node).checked"
                [indeterminate]="tree.getCheckboxState(node).indeterminate"
                (ngModelChange)="onNodeChanges(node, $event)"
                (click)="onCheckBoxClick(node, $event)"
                [invokeInitialChangeCallback]="false"
            >
                <ng-container *ngIf="labelTemplate">
                    <ng-container [ngComponentOutlet]="labelTemplate" [ndcDynamicInputs]="{node: node}"></ng-container>
                </ng-container>
                <ng-container *ngIf="!labelTemplate">
                    {{ node.label }}
                </ng-container>
            </checkbox>
        </div>
        <div class="node-children" *ngIf="node.hasChildren()" [customProperty]="{'--children-count': tree.getChildrenCount(node)}">
            <ng-container *ngIf="tree.isChildrenExpanded(node)">
                <ng-container
                    *ngTemplateOutlet="nodesList; context: {$implicit: {nodes: node.children, level: context.level + 1}}"
                ></ng-container>
            </ng-container>
        </div>
    </div>
</ng-template>

<div class="tree-presets" (click)="$event.stopPropagation()">
    <div class="tree-preset" *ngIf="selectAllPreset && nodes.length" data-preset="selectAll">
        <checkbox [ngModel]="isAllSelected(selected)" (ngModelChange)="onToggleAll($event)">{{ selectAllPreset.label }}</checkbox>
    </div>
    <div class="tree-preset" *ngFor="let preset of presets; let i = index" [attr.data-preset]="i">
        <checkbox [ngModel]="isPresetActive(preset)" (ngModelChange)="onPresetToggle(preset, $event)">{{ preset.label }}</checkbox>
    </div>
</div>

<div
    [attr.data-no-results]="noOptionsPlaceholder"
    class="nodes-wrapper"
    (click)="$event.stopPropagation()"
    [customProperty]="{'--total-count': totalCount}"
>
    <ng-container *ngTemplateOutlet="nodesList; context: {$implicit: {nodes: tree.items, level: 0}}"></ng-container>
</div>
